import { useState, useEffect } from "react";
import {
    AutocompleteOption,
    ControlledAutocompleteVariant,
} from "../components/ControlledAutocomplete";
import { controlledAutocomplete } from "../api/controlledAutocomplete";

export const useControlledAutocomplete = (type: ControlledAutocompleteVariant) => {

    const [value, setValue] = useState<AutocompleteOption | null>(null);
    const [options, setOptions] = useState<AutocompleteOption[]>([]);
    const [search, setSearch] = useState<string>("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(async () => {
            if (type === "PROJECT" && search?.trim()?.length < 2) return;

            setLoading(true);
            try {
                const response = await controlledAutocomplete.get({
                    type,
                    search_term: search,
                });
                setOptions(Array.isArray(response) ? response : []);
            } finally {
                setLoading(false);
            }
        }, 400);

        return () => clearTimeout(timeout);
    }, [search, type]);

    return {
        value,
        options,
        loading,
        onChange: (_type: ControlledAutocompleteVariant, newValue: any) => {
            setValue(newValue);
        },
        onInputChange: (_e: any, val: string | null) => {
            setSearch(val ?? "");
        },
    };
    
};
